import { FlickeringFooter } from '@/components/ui'

export default function LandingFooter() {
  return <FlickeringFooter />
}
